<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 项目展示
    </div>
    <div class="content-info">
      <div class="content-info-title">项目展示</div>


      <div class="project-nav">
        <div class="nav-box">
          <router-link to="/home/addOrg" class="to-addorg"></router-link>

        </div>
      </div>


      <p style="text-align: right;width: 95%;margin: 20px auto 0;color: #f9aa0d">注：最多可填写5个项目</p>
      <el-table
        class="content-info-list"
        border
        :data="tableData"
        header-row-class-name="table-header"
        style="width: 95%">

        <el-table-column
          label="序号"
          type="index"
          width="90">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.index }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="project_no"
          label="项目名称">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.entry_name }}
            </div>
          </template>
        </el-table-column>
        <!--<el-table-column-->
        <!--label="申报金额（万元）"-->
        <!--width="150">-->
        <!--<template slot-scope="scope">-->
        <!--<div class="table-item">-->
        <!--{{scope.row.amount}}-->
        <!--</div>-->
        <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column
          prop="society"
          label="状态"
          width="150">
          <template slot-scope="scope">
            <div class="table-item">
              <span v-if="scope.row.status ===0">未提交</span>
              <span v-if="scope.row.status ===1 || scope.row.status ===-1 ">已提交</span>
              <span v-if="scope.row.status ===2">待补充信息</span>
              <span v-if="scope.row.status ===3">审核未通过</span>
              <span v-if="scope.row.status ===4">审核中</span>
              <span v-if="scope.row.status ===5">审核通过</span>
              <span v-if="scope.row.status ===6">审核未通过</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="340">
          <template slot-scope="scope">
            <div class="table-operate">
              <router-link :to="'/home/projectDetail?id='+scope.row.id"
                 v-if="scope.row.status ===1 ||scope.row.status ===-1 ||scope.row.status ===2 ||scope.row.status ===4||scope.row.status ===5">
                <span class="table-operate-item">查看</span>
              </router-link>
              <router-link :to="'/home/addProject?id=' + scope.row.id"
                           v-if="scope.row.status ===0 ||scope.row.status ===1 ||scope.row.status ===-1 ||scope.row.status ===3 ||scope.row.status ===6">
                <span class="table-operate-item">修改</span>
              </router-link>
              <span class="table-operate-item active" v-if="scope.row.status ===3||scope.row.status ===6"
                    @click="remarkItem(scope.row.reason)">
                原因
              </span>
              <span class="table-operate-item active" v-if="scope.row.status ===2"
                    @click="supplementItem(scope.row.id)">
                补充信息
              </span>
              <span class="table-operate-item active"
                    v-if="scope.row.status ===0 || scope.row.status ===3||scope.row.status ===6"
                    @click="submitItem(scope.row.id)">
                提交
              </span>
              <span class="table-operate-item active"
                    v-if="scope.row.status ===0 || scope.row.status ===3||scope.row.status ===6"
                    @click="delItem(scope.row.id)">删除</span>

            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="200">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.init_time }}
            </div>
          </template>
        </el-table-column>

      </el-table>
      <div class="project-add" v-if="tableData.length < 5">
        <el-button round @click="toAdd"><i class="iconfont iconshenbao" style="font-size: 24px"
        ></i> 添加
        </el-button>
      </div>
    </div>
    <el-dialog
      title="原因"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>{{ reason }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="信息补充"
      :visible.sync="dialogVisible2"
      width="600px"
      :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item label="可服务范围及人群" prop="server">
          <el-input type="textarea" v-model="form.server" placeholder="请填写可服务范围及人群"></el-input>
        </el-form-item>
        <el-form-item label="可对接合作的资方" prop="zifang">
          <el-checkbox-group v-model="form.zifang">
            <el-checkbox label="街道社区" name="zifang"></el-checkbox>
            <el-checkbox label="其他政府职能部门" name="zifang"></el-checkbox>
            <el-checkbox label="基金会" name="zifang"></el-checkbox>
            <el-checkbox label="企业" name="zifang"></el-checkbox>
            <el-checkbox label="公众" name="zifang"></el-checkbox>
            <el-checkbox label="其他" name="zifang">其他
              <el-input v-model="zifangOther" v-if="form.zifang.indexOf('其他')!==-1" style="width: 150px;"
                        size="mini" placeholder="请填写"></el-input>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <span class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitSupplement('form')">确 定</el-button>
      </span>
        </el-form-item>
      </el-form>

    </el-dialog>

  </div>
</template>
<script>
export default {
  name: "projectList",
  data() {
    var validatejyOther = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请选择可对接合作的资方'));
      } else {
        if (value.indexOf('其他') !== -1 && !this.zifangOther) {
          callback(new Error('请输入其他'));
        } else {
          callback();
        }
      }
    };
    return {
      tableData: [],
      dialogVisible: false,
      reason: '',
      supplementId: '',
      dialogVisible2: false,

      form: {
        server: '',
        zifang: []
      },
      zifangOther: '',
      rules: {
        server: [
          {required: true, message: '请输入可服务范围及人群', trigger: 'blur'},
        ],
        zifang: [
          {required: true, message: '请选择可对接合作的资方', trigger: 'change'},
          {validator: validatejyOther, trigger: 'change'}
        ],
      }
    }
  },
  created() {
    this.$emit('setIndex', 2)
    this.init()
  },
  methods: {
    supplementItem(id) {
      this.supplementId = id

      this.dialogVisible2 = true
      this.form = {
        server: '',
        zifang: []
      }
      this.zifangOther = ''
      this.$refs['form'].clearValidate();
    },
    submitSupplement(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.apiContent.supplement({
            token: this.$store.state.user.token,
            apply_id: this.supplementId,
            service_scope: this.form.server,
            stakeholders: this.form.zifang.join(','),
            stakeholders_other: this.form.zifang.indexOf('其他') === -1 ? '' : this.zifangOther
          }).then(() => {
            this.supplementId = ''
            this.dialogVisible2 = false
            this.form = {
              server: '',
              zifang: []
            }
            this.zifangOther = ''
            this.init()
          }).catch(e => {
            this.$message.error(e.msg)
          })
        }
      });
    },


    toAdd() {
      this.$api.apiContent.baseInfo({
        token: this.$store.state.user.token,
      }).then(() => {
        this.$router.push('/home/addProject')
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisible2 = false
    },
    remarkItem(reason) {
      this.reason = reason
      this.dialogVisible = true
    },
    delItem(id) {
      let that = this
      that.$confirm('你确定要删除该项目吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.$api.apiContent.delProject({
          token: that.$store.state.user.token,
          apply_id: id
        }).then(res => {
          that.init()
          that.$message.success(res.msg)
        }).catch(e => {
          that.$message.error(e.msg)
        })
      }).catch();

    },
    submitItem(id) {
      let that = this
      that.$confirm('你确定要提交该项目吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.$api.apiContent.submitProject({
          token: that.$store.state.user.token,
          apply_id: id
        }).then(res => {
          that.init()
          that.$message.success(res.msg)
        }).catch(e => {
          that.$message.error(e.msg)
        })
      }).catch();
    },
    init() {
      this.$api.apiContent.applyList({
        token: this.$store.state.user.token
      }).then(res => {
        this.tableData = res.data
        this.tableData.map((item, index) => {
          item.entry_name = item.entry_name ? item.entry_name : '--'
          item.update_time = item.update_time ? item.update_time : '--'
          item.index = index + 1
        })
      }).catch(() => {
        this.tableData = []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.content-info {
  display: flex;
  flex-direction: column;
  min-height: 950px;

  .content-info-title {
    display: flex;
    flex-direction: row;
    height: 56px;
    line-height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    justify-content: space-between;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }
  }

  .project-add {
    display: block;
    margin: 20px auto;
    width: 200px;
    height: 50px;

    .el-button {
      width: 200px;
      height: 50px;
      align-self: center;
      background-image: linear-gradient(90deg, #f9aa0d 0%, #e44730 100%), linear-gradient(#f9aa0d, #f9aa0d);
      padding: 0 40px;
      color: #fff;
      border-radius: 25px;
      font-size: 18px;
      border: 0;

      i {
        position: relative;
        top: 3px;
      }
    }
  }

  .project-nav {
    width: 95%;
    margin: 20px auto;
    height: 70px;
    background: #f5f5f5;

    .nav-box {
      width: 524px;
      height: 70px;
      margin: 0 auto;
      background: url(../../assets/img/projectnav.jpg) no-repeat;

      .to-addorg {
        display: block;
        width: 50%;
        height: 70px;
      }
    }
  }

  .content-info-list {
    margin-top: 20px;
    align-self: center;
    margin-bottom: 30px;

    .table-operate {
      text-align: center;

      .table-operate-item {
        font-size: 16px;
        width: 75px;
        display: inline-block;
        cursor: pointer;

        &.active {
          position: relative;

          &:before {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(0, -50%);
            content: '';
            width: 1px;
            height: 18px;
            background-color: #333333;
          }
        }
      }
    }

    .table-item {
      text-align: center;
    }
  }
}
</style>
